import React from "react";
import SEO from "../components/SEO";
import refundData from "../data/refundPolicy.json";

export default function RefundPolicy() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={refundData.seo?.title}
        description={refundData.seo?.description}
        ogType="website"
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {refundData.eyebrow}
        </p>
        <h1 className="page-title mt-3">{refundData.title}</h1>
        <p className="mt-4 text-lg text-slate-600">{refundData.subtitle}</p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-4 md:grid-cols-2">
          {/* <!-- Replace with dynamic content from JSON --> */}
          {refundData.sections.map((item) => (
            <div key={item.title} className="card p-6">
              <h2 className="text-base font-semibold text-slate-900">
                {item.title}
              </h2>
              <p className="mt-2 text-sm text-slate-600">{item.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
